import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TeamDevelopmentCalendarRoutingModule } from "./team-development-calendar-routing.module";
import { SharedModule } from "../../shared/shared.module";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { WorkoutsReducer } from "./store/workouts.reducer";
import { WorkoutsEffects } from "./store/workouts.effects";
import { Fields } from "./store";
import { TeamDevelopmentCalendarPlayersComponent } from "./team-player-list/player-list.component";
import { DevelopmentCalendarPlayerComponent } from "./development-calendar-player/development-calendar-player.component";
import { TeamDevelopmentCalendarComponent } from "./team-development-calendar.component";

@NgModule({
  imports: [
    CommonModule,
    TeamDevelopmentCalendarRoutingModule,

    SharedModule,

    StoreModule.forFeature(Fields.Module, WorkoutsReducer),
    EffectsModule.forFeature([WorkoutsEffects]),
  ],
  declarations: [
    TeamDevelopmentCalendarComponent,
    TeamDevelopmentCalendarPlayersComponent,
    DevelopmentCalendarPlayerComponent
  ],
})
export class TeamDevelopmentCalendarModule {}



// WEBPACK FOOTER //
// ./src/app/pages/team-development-calendar/team-development-calendar.module.ts